var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_457)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_547_457",
    maskUnits: "userSpaceOnUse",
    x: -2.59961,
    y: -2.5,
    width: 46,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -2.59961,
    y: -2.5,
    width: 46,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7936 0.5H11.627C4.91479 0.5 0.400391 5.0696 0.400391 11.8664V27.5528C0.400391 34.3304 4.91479 38.9 11.627 38.9H28.7936C35.5058 38.9 40.0004 34.3304 40.0004 27.5528V11.8664C40.0004 5.0696 35.5058 0.5 28.7936 0.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7936 0.5H11.627C4.91479 0.5 0.400391 5.0696 0.400391 11.8664V27.5528C0.400391 34.3304 4.91479 38.9 11.627 38.9H28.7936C35.5058 38.9 40.0004 34.3304 40.0004 27.5528V11.8664C40.0004 5.0696 35.5058 0.5 28.7936 0.5Z",
    fill: "#0079BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7936 3.5C30.4504 3.5 31.7936 2.15685 31.7936 0.5C31.7936 -1.15685 30.4504 -2.5 28.7936 -2.5V3.5ZM28.7936 -2.5C27.1367 -2.5 25.7936 -1.15685 25.7936 0.5C25.7936 2.15685 27.1367 3.5 28.7936 3.5V-2.5ZM28.7936 -2.5H11.627V3.5H28.7936V-2.5ZM11.627 -2.5C7.57137 -2.5 3.96173 -1.10547 1.36228 1.52618C-1.23405 4.15467 -2.59961 7.79079 -2.59961 11.8664H3.40039C3.40039 9.14521 4.29203 7.09813 5.63095 5.74262C6.96675 4.39027 8.97041 3.5 11.627 3.5V-2.5ZM-2.59961 11.8664V27.5528H3.40039V11.8664H-2.59961ZM-2.59961 27.5528C-2.59961 31.621 -1.23261 35.2524 1.36355 37.8775C3.96261 40.5056 7.57148 41.9 11.627 41.9V35.9C8.9703 35.9 6.96587 35.0096 5.62968 33.6585C4.29059 32.3045 3.40039 30.2622 3.40039 27.5528H-2.59961ZM11.627 41.9H28.7936V35.9H11.627V41.9ZM28.7936 41.9C32.8496 41.9 36.4551 40.5052 39.0498 37.8748C41.6408 35.2483 43.0004 31.6172 43.0004 27.5528H37.0004C37.0004 30.266 36.1127 32.3085 34.7783 33.6612C33.4477 35.01 31.4498 35.9 28.7936 35.9V41.9ZM43.0004 27.5528V11.8664H37.0004V27.5528H43.0004ZM43.0004 11.8664C43.0004 7.79456 41.6422 4.15876 39.0511 1.52887C36.4559 -1.10503 32.8497 -2.5 28.7936 -2.5V3.5C31.4497 3.5 33.4468 4.38983 34.7771 5.73993C36.1113 7.09405 37.0004 9.14144 37.0004 11.8664H43.0004Z",
    fill: "#0079BF",
    mask: "url(#path-2-outside-1_547_457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1296 26.1001C14.0231 26.1001 9.96968 21.5956 9.80078 14.1001H13.3606C13.4775 19.6016 16.1018 21.9319 18.1805 22.4124V14.1001H21.5325V18.8448C23.5852 18.6406 25.7416 16.4785 26.4692 14.1001H29.8211C29.2625 17.031 26.924 19.1932 25.261 20.0821C26.924 20.8028 29.5874 22.6887 30.6008 26.1001H26.911C26.1185 23.8178 24.1439 22.052 21.5325 21.8118V26.1001H21.1296Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    y: 0.5,
    width: 39.6,
    height: 38.4,
    rx: 19.2,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.811cbc560436d0da0c4c765abb76e395.svg";
export { ForwardRef as ReactComponent };